<template>
  <!-- 顶部操作 查看文件类型筛选  组件 author: zhangxiaofeng -->
  <div class="operation-file-type f-cb">
    <w-select v-model="checkedVal" size="small" placeholder="请选择" @change="handlerChange">
      <w-option
        v-for="item in radios"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </w-option>
    </w-select>
    <!--<template v-for="(item, idx) in radios">-->
      <!--<input type="radio" class="float_left"-->
             <!--v-model="checkedVal"-->
             <!--:key="idx"-->
             <!--:value="item.value"-->
             <!--:id="'selectFile_' + item.value" name="selectFile">-->
      <!--<label class="float_left" :for="'selectFile_' + item.value" :key="'label_' + idx">-->
        <!--{{item.label}}-->
      <!--</label>-->
    <!--</template>-->
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .operation-file-type{
    color: #666;
    font-size: 14px;
    input{
      margin-top: 8px;
      cursor: pointer;
    }
    label{
      padding-left: 2px;
      margin-right: 20px;
      cursor: pointer;
      user-select: none;
    }
  }
</style>
<script>
export default {
  name: 'OperationFileType',
  props: {
    checked: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      lastChecked: '',
      checkedVal: '',
      radios: [
        {label: '全部文件', value: 0},
        {label: '计量文件', value: 2},
        {label: '计价文件', value: 1}
      ]
    }
  },
  created () {
    // let checkedVal = this.radios[0].value
    // if (this.checked) {
    //   this.radios.forEach((item) => {
    //     if (item.value === this.checked) {
    //       checkedVal = this.checked
    //     }
    //   })
    // }
    this.checkedVal = this.checked
    this.lastChecked = this.checked
  },
  watch: {
    // 'checkedVal': function () {
    //   if (this.lastChecked !== this.checkedVal) {
    //     this.lastChecked = this.checkedVal
    //     this.$emit('change', {fileType: this.checkedVal})
    //   }
    // }
  },
  methods: {
    handlerChange () {
      this.$emit('change', {fileType: this.checkedVal})
    }
  }
}
</script>
